import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";

function LoginForm(props) {
  const [field, setField] = useState({
    username: "",
    password: "",
    store: false,
  });
  const [form, setForm] = useState(false);
  const [login, setLogin] = useState(false);
  const [alert, setAlert] = useState({
    state: false,
    data: null,
  });

  useEffect(() => {
    if (localStorage.getItem("user") || sessionStorage.getItem("user")) {
      setLogin(true);
    }
  }, []);

  const validateField = () => true;

  const valueChanged = (event) => {
    const element = event.target;
    if (validateField(element)) {
      setField((prev) => ({
        ...prev,
        [element.id]: element.id === "store" ? element.checked : element.value,
      }));
    }
  };

  const validate = (event) => {
    event.preventDefault();

    setAlert({
      state: false,
      data: null,
    });

    setTimeout(() => {
      setAlert({
        state: true,
        data: {
          status: "#747474",
          message: "logging in...",
        },
      });
    }, 500);

    axios
      .post(
        props.chimeraserv.urlGet + "/login",
        {
          username: field.username,
          password: field.password,
        },
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const body = response.data;

        if (!body.error && response.status === 200) {
          setAlert({
            state: true,
            data: {
              status: "#61bd1a",
              message: "Login successful!",
            },
          });

          sessionStorage.setItem("isRemindered", "false");

          setTimeout(() => {
            if (field.store) {
              localStorage.setItem("user", window.btoa(JSON.stringify(body)));
              sessionStorage.setItem("user", window.btoa(JSON.stringify(body)));
            } else {
              sessionStorage.setItem("user", window.btoa(JSON.stringify(body)));
            }
            setForm(true);
          }, 500);
        } else {
          setTimeout(() => {
            setAlert({
              state: true,
              data: {
                status: "#d62424",
                message: "Incorrect Username or Password.",
              },
            });
          }, 1500);
        }
      })
      .catch(() => {
        setTimeout(() => {
          setAlert({
            state: true,
            data: {
              status: "#d62424",
              message: "Incorrect Username or Password.",
            },
          });
        }, 1500);
      });
  };

  if (login || form) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className={["login"]}>
      <form onSubmit={validate}>
        <div className={["form-group"]}>
          <FontAwesomeIcon
            className={["icon"].join(" ")}
            icon={["fas", "user-circle"]}
          />
          <input
            type={"text"}
            className={["form-control"]}
            id={"username"}
            placeholder={"username"}
            value={field.username}
            onChange={valueChanged}
          />
        </div>
        <div className={["form-group"]}>
          <FontAwesomeIcon
            className={["icon"].join(" ")}
            icon={["fas", "key"]}
          />
          <input
            type={"password"}
            className={["form-control"]}
            id={"password"}
            placeholder={"password"}
            value={field.password}
            onChange={valueChanged}
          />
        </div>
        <div className={["custom-control", "custom-checkbox"].join(" ")}>
          <input
            type={"checkbox"}
            className={["custom-control-input"]}
            id={"store"}
            checked={field.store}
            onChange={valueChanged}
          />
          <label className={"custom-control-label"} htmlFor={"store"}>
            Remember me
          </label>
        </div>

        <div
          className={["statusContainer"].join(" ")}
          style={alert.data ? { color: alert.data.status } : {}}
        >
          {alert.state ? (
            alert.data.message
          ) : (
            <div className={["breakSpace"]} />
          )}
        </div>

        <button
          type={"submit"}
          className={["btn btn-primary"]}
          disabled={!(field.username && field.password)}
        >
          Login
        </button>
      </form>

      {/* <Link className={["formLink"].join(" ")} to="/login/forgot">
        Forgot Password
      </Link> */}
    </div>
  );
}

export default LoginForm;
